import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../../_metronic/helpers'
import { getRequest } from '../Helpers/Requests'
import PaginatedItems from '../../UI/PaginatedItems'
import AddPartner from '../../../_metronic/partials/modals/OCPI/AddPartner'
import EditPartner from '../../../_metronic/partials/modals/OCPI/EditPartner'

const Emobilites = () => {
  const [modalId, setModalId] = useState<number | null>(null)
  const [data, setData] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [limit] = useState<number>(8)
  const [pages, setPages] = useState<number>(1)
  const [search, setSearch] = useState<string>('')
  const [status, setStatus] = useState<string>('') // '' = ALL
  const [selectedPartnerId, setSelectedPartnerId] = useState(null)


  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      const toast = document.createElement('div')
      toast.className = 'position-fixed top-0 end-0 p-3'
      toast.style.zIndex = '9999'
      toast.innerHTML = `
        <div class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="toast-header bg-success text-white">
            <strong class="me-auto">Success</strong>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast"></button>
          </div>
          <div class="toast-body">
            Token copied to clipboard successfully!
          </div>
        </div>
      `
      document.body.appendChild(toast)

      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast)
        }
      }, 3000)

      console.log('Token copied to clipboard')
    } catch (err) {
      console.error('Failed to copy token: ', err)
      // Show error toast
      const toast = document.createElement('div')
      toast.className = 'position-fixed top-0 end-0 p-3'
      toast.style.zIndex = '9999'
      toast.innerHTML = `
        <div class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="toast-header bg-danger text-white">
            <strong class="me-auto">Error</strong>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast"></button>
          </div>
          <div class="toast-body">
            Failed to copy token to clipboard
          </div>
        </div>
      `
      document.body.appendChild(toast)

      // Remove toast after 3 seconds
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast)
        }
      }, 3000)
    }
  }

  const fetchData = async () => {
    try {
      const query = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search ? { search } : {}),
        ...(status && status !== 'All' ? { status } : {}),
      }).toString()

      const response = await getRequest(`/ocpi/msp?${query}`)

      if (response && response.data) {
        setData(response.data.data || [])
        setPages(response.data.pagination?.totalPages || 1)
      } else {
        console.error('No data found in response')
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [page, search, status])

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
    setPage(1) // reset to first page when searching
  }

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatus(e.target.value)
    setPage(1) // reset to first page when filtering
  }

  // Format date for display
  const formatDateTime = (dateString: string) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  }



  return (
    <>
      <div className='card'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>e-Mobility Partners</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Manage your connected partners</span>
          </h3>
          <div className='card-toolbar d-flex gap-5'>
            {/* Status Filter */}
            <div style={{ width: '200px' }}>
              <select
                className='form-select form-control'
                value={status || 'All'}
                onChange={handleStatusChange}
              >
                <option value='All'>ALL</option>
                <option value='ACTIVE'>ACTIVE</option>
                <option value='INACTIVE'>INACTIVE</option>
              </select>
            </div>

            {/* Search */}
            <div style={{ width: '200px' }}>
              <input
                type='text'
                className='form-control'
                placeholder='Search Partner'
                value={search}
                onChange={handleSearchChange}
              />
            </div>

            {/* Add New */}
            <button
              type='button'
              className='btn btn-sm btn-light-success'
              data-bs-toggle='modal'
              data-bs-target='#add_partner'
            >
              <KTIcon iconName='plus' className='fs-2' />
              Add New Partner
            </button>
          </div>
        </div>

        <div className='card-body py-4'>
          <div className='table-responsive'>
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted bg-light'>
                  {/* <th className='min-w-80px ps-6 pe-6 py-4'>ID</th> */}
                  <th className='min-w-100px ps-6 pe-6 py-4'>COUNTRY CODE</th>
                  <th className='min-w-100px ps-6 pe-6 py-4'>PARTY ID</th>
                  <th className='min-w-150px ps-6 pe-6 py-4'>BUSINESS NAME</th>
                  <th className='min-w-100px ps-6 pe-6 py-4'>ROLE</th>
                  <th className='min-w-120px ps-6 pe-6 py-4'>OCPI VERSION</th>
                  <th className='min-w-120px ps-6 pe-6 py-4'>TOKEN</th>
                  <th className='min-w-120px ps-6 pe-6 py-4'>MSP TOKEN</th>
                  <th className='min-w-120px ps-6 pe-6 py-4'>STATUS</th>
                  <th className='min-w-120px ps-6 pe-6 py-4'>CREATED</th>
                  <th className='min-w-150px text-end ps-6 pe-6 py-4'>ACTIONS</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item) => (
                    <tr key={item.id} className='border-bottom border-gray-200'>
                      {/* <td className='ps-6 pe-6 py-4'>
                        <span className='badge badge-light-primary fs-7 fw-bold'>{item.id || 'N/A'}</span>
                      </td> */}
                      <td className='ps-6 pe-6 py-4'>
                        <span className='badge badge-light-success fs-7 fw-bold'>{item.country_code || 'N/A'}</span>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <span className='text-dark fw-bold fs-6'>{item.party_id || 'N/A'}</span>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <div className='d-flex align-items-center'>
                          {item.business_logo ? (
                            <div className='symbol symbol-50px me-5'>
                              <img
                                src={item.business_logo}
                                alt='Logo'
                                className='rounded-circle'
                                style={{ width: '40px', height: '40px' }}
                              />
                            </div>
                          ) : (
                            <div className='symbol symbol-50px me-5'>
                              <span className='symbol-label bg-light-primary text-primary fw-bold fs-7'>
                                {item.business_name?.substring(0, 2) || 'N/A'}
                              </span>
                            </div>
                          )}
                          <div className='d-flex justify-content-start flex-column'>
                            <span className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                              {item.business_name || 'N/A'}
                            </span>
                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                              {item.business_website || 'No Website'}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <span className='badge badge-light-info fs-7 fw-bold'>{item.role || 'N/A'}</span>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <span className='fw-bold text-warning fs-7'>{item.ocpi_version || 'N/A'}</span>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <div
                          className='cursor-pointer'
                          title={`Click to copy: ${item.tokenA || 'N/A'}`}
                          onClick={() => copyToClipboard(item.tokenA || '')}
                          style={{ cursor: 'pointer' }}
                        >
                          <small className='text-muted fw-semibold'>
                            {item.tokenA ? `${item.tokenA.substring(0, 8)}...` : 'N/A'}
                          </small>
                        </div>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <div
                          className='cursor-pointer'
                          title={`Click to copy: ${item.tokenB || 'N/A'}`}
                          onClick={() => copyToClipboard(item.tokenB || '')}
                          style={{ cursor: 'pointer' }}
                        >
                          <small className='text-muted fw-semibold'>
                            {item.tokenB ? `${item.tokenB.substring(0, 8)}...` : 'N/A'}
                          </small>
                        </div>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <span
                          className={`badge fs-7 fw-bold ${item.status === 'ACTIVE' ? 'badge-light-success' : 'badge-light-danger'
                            }`}
                        >
                          {item.status || 'N/A'}
                        </span>
                      </td>
                      <td className='ps-6 pe-6 py-4'>
                        <span className='text-dark fw-bold fs-7'>{formatDateTime(item.createdAt)}</span>
                      </td>
                      <td className='text-end ps-6 pe-6 py-4'>
                        <Link
                          to={`/EmobilityService/${item.id}`}
                          type='button'
                          className='btn btn-icon btn-bg-light btn-active-color-success btn-sm me-2'
                          title='View Services'
                        >
                          <KTIcon iconName='eye' className='fs-3' />
                        </Link>
                        <button
                          type='button'
                          className='btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2'
                          data-bs-toggle='modal'
                          data-bs-target='#edit_partner'
                          onClick={() => {
                            setSelectedPartnerId(item?.id)
                            console.log(item?.id)
                          }}
                          title='Edit Partner'
                        >
                          <KTIcon iconName='pencil' className='fs-3' />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={11} className='text-center py-5'>
                      <div className='d-flex flex-column align-items-center'>
                        <KTIcon iconName='search-list' className='fs-2 text-muted mb-3' />
                        <span className='text-muted fs-6'>No partners found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className='card-footer'>
            <PaginatedItems setPage={setPage} pages={pages} currentPage={page} />
          </div>
        </div>

        {/* Confirm Modal */}
        <div className='modal fade' id='confirm_modal' tabIndex={-1} aria-hidden='true'>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Confirm Delete</h5>
                <button type='button' className='btn-close' data-bs-dismiss='modal'></button>
              </div>
              <div className='modal-body'>
                Are you sure you want to delete partner with ID <b>{modalId}</b>?
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Cancel
                </button>
                <button type='button' className='btn btn-danger'>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddPartner />

      <EditPartner partnerId={selectedPartnerId} />
    </>
  )
}

export default Emobilites
